/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderExtendRequestSchema } from "./mobileOrderExtendRequestSchema.ts";
import { mobileOrderExtendSchema } from "./mobileOrderExtendSchema.ts";

export const orgUnitOrderExtendCreatePathOrderIdSchema = z.uuid();

export const orgUnitOrderExtendCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitOrderExtendCreateStatus200Schema = mobileOrderExtendSchema;

export const orgUnitOrderExtendCreateResponseSchema = orgUnitOrderExtendCreateStatus200Schema;

export const orgUnitOrderExtendCreateDataSchemaJson = mobileOrderExtendRequestSchema;

export const orgUnitOrderExtendCreateDataSchemaXml = mobileOrderExtendRequestSchema;

export const orgUnitOrderExtendCreateDataSchema = z.union([orgUnitOrderExtendCreateDataSchemaJson, orgUnitOrderExtendCreateDataSchemaXml]);
